import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import "./TaskManager.css";
import { Link } from "react-router-dom";
import moment from "moment";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import { useLanguage } from "../../Providers/LanguageContext";
import Select from 'react-select'; // Import react-select
import { formatDateForInput } from "../../utils/convertDateToTimezone";


function TaskPopUp({ closemodal, detailData, getTaskData, intendedTaskId, intendedTaskStatus, setIntendedTaskStatus, fetchEntireTask, isFromTaskList, setIsUpdate, isZIndex }) {
  const { language } = useLanguage();
  const [taskStatus, setTaskStatus] = useState('');
  const [taskNotes, setTaskNotes] = useState('');
  const [allUser, setAllUser] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [isAssignUser, setIsAssignUser] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]); // Changed to array for multi-select
  const [selectedProjectName, setSelectedProjectName] = useState('');
  const [allAssignedUsers, setAllAssignedUsers] = useState([]);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);

  const toggleUserModal = () => {
    setIsUserModalOpen(!isUserModalOpen);
  };

  useEffect(() => {
    if (detailData?.assignToUserNames) {
      setAllAssignedUsers(detailData?.assignToUserNames || []);
    }
  }, [detailData?.assignToUserNames]);



  const fetchAllProjects = async () => {
    try {
      const response = await HttpClient.requestData('view-all-project', 'GET');
      if (response && response?.status) {
        setSelectedProjectName(response?.data?.find(project => project._id === detailData?.assignToProject)?.projectName || '');
      } else {
        toast.error(response?.message || 'Something Went Wrong!!!');
        setSelectedProjectName('');
      }
    } catch (error) {
      toast.error(error?.message || 'Something Went Wrong!!!');
      setSelectedProjectName('');
    }
  };

  useEffect(() => {
    if (detailData?.assignToProject) {
      fetchAllProjects();
    }
  }, [detailData?.assignToProject])

  useEffect(() => {
    isFromTaskList && fetchAllUsers();
  }, [isFromTaskList]);

  useEffect(() => {
    // Initialize selected users from detailData
    if (detailData?.assignedToUser) {
      // If assignedToUser is a single ID, convert to array format for react-select
      const initialUsers = Array.isArray(detailData.assignedToUser)
        ? detailData.assignedToUser
        : [detailData.assignedToUser];

      // Convert to react-select format if we have user data
      if (allUser.length > 0) {
        const userOptions = initialUsers.map(userId => {
          const user = allUser.find(u => u._id === userId);
          return user ? { value: user._id, label: user.name } : null;
        }).filter(Boolean);
        setSelectedUsers(userOptions);
      }
    } else if (detailData?.assignToUser) {
      // If assignToUser is an array of IDs
      const initialUsers = detailData.assignToUser;
      const userOptions = initialUsers.map(userId => {
        const user = allUser.find(u => u._id === userId);
        return user ? { value: user._id, label: user.name } : null;
      }).filter(Boolean);
      setSelectedUsers(userOptions);
    }
  }, [detailData, allUser]);

  // Convert users to react-select options
  const userOptions = useMemo(() => {
    return allUser.map(user => ({
      value: user._id,
      label: user.name
    }));
  }, [allUser]);

  useEffect(() => {
    setTaskNotes(detailData?.taskNotes || '');
  }, [detailData]);

  useEffect(() => {
    // Always use the status from detailData, not from any global state
    if (detailData?.taskStatus) {
      setTaskStatus(detailData.taskStatus);
    }
  }, [detailData?.taskStatus]);


  console.log("detailDatadff", detailData)

  const handleSaveDone = async () => {
    const data = {
      "taskName": detailData.taskName,
      "taskNotes": detailData.taskNote,
      "taskStatus": detailData.taskStatus ? detailData.taskStatus : "open",
      "assignToUser": detailData.assignedUser,
      "selectDate": moment(detailData.date).format("YYYY-MM-DD"),
      "Time": moment(detailData.date).format("h:mm a")
    }
    const res = await HttpClient.requestData("add-task-eventDetails", "POST", data)
    // console.log("ressff", res)
    if (res && res?.status) {
      toast.success("Task Added Successfully");
      // clearState();
      getTaskData();
      closemodal();
    } else {
      toast.error(res?.message || 'Something went wrong!!!');
    }
  }

  const fetchAllUsers = async () => {
    try {
      const response = await HttpClient.requestData("getUser", "GET");
      if (response && response?.status) {
        setAllUser(response?.data);
      } else {
        // toast.error(response?.message || 'Something went wrong!!!');
        setAllUser([]);
      }
    } catch (error) {
      // toast.error(error?.message || 'Something went wrong!!!');
      setAllUser([]);
    }
  };

  const handleIntendedUpdateStatus = async () => {
    // if (!e.target.value) return
    const data = {
      taskStatus: intendedTaskStatus,
      taskNotes,
    };
    const res = await HttpClient.requestData("update-task-eventDetails/" + intendedTaskId, "PUT", data)
    if (res && res?.status) {
      getTaskData();
      toast.success("Status Updated Sucessfully");
    }
  };

  const handleSelectStatus = async () => {
    if (!taskStatus) return;
    let data = null;
    if (isAssignUser) {
      const assignedUserIds = selectedUsers.map(user => user.value);
      data = {
        taskStatus,
        taskNotes,
        assignToUser: assignedUserIds,
      };
    } else {
      data = {
        taskStatus,
        taskNotes,
      };
    }
    const res = await HttpClient.requestData("update-task-eventDetails/" + detailData?._id, "PUT", data)
    if (res && res?.status) {
      getTaskData();
      fetchEntireTask();
      setIsUpdate && setIsUpdate(true); // This triggers the filter reapplication in TodoList
      closemodal();
      toast.success("Status Updated Successfully");
      setIsAssignUser(false);
    }
  };

  // console.log('detailData: ', detailData);
  const taskref = useRef()
  useEffect(() => {
    const HandleCLickOutside = (e) => {
      if (taskref.current && !taskref.current.contains(e.target)) {
        closemodal(false)
      }

    }
    document.addEventListener('mousedown', HandleCLickOutside)
  }, []);

  // useLayoutEffect(() => {
  //   fetchEntireTask();
  // }, []);

  console.log(isFromTaskList, "isFromTaskList");

  // console.log("detailData?.assignToUserNames", detailData?.assignToUserNames);

  // User Modal Component
  const UserModal = ({ users, onClose }) => {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          maxWidth: '400px',
          width: '90%',
          maxHeight: '80vh',
          overflowY: 'auto'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
            borderBottom: '1px solid #eee',
            paddingBottom: '10px'
          }}>
            <h4 style={{ margin: 0 }}>Assigned Users</h4>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '18px',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              ×
            </button>
          </div>

          {users.length > 0 ? (
            <div>
              {users.map((user, index) => (
                <div key={index} style={{
                  padding: '10px',
                  border: '1px solid #eee',
                  borderRadius: '4px',
                  marginBottom: '8px',
                  backgroundColor: '#f9f9f9'
                }}>
                  <strong>{user}</strong>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ textAlign: 'center', color: '#666' }}>No users assigned</p>
          )}

          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <button
              onClick={onClose}
              style={{
                backgroundColor: '#0C2537',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  console.log("isZIndex: ", isZIndex);

  return (
    <>
      <section className="taskPopSection" style={{
        zIndex: isZIndex ? 1000 : 'auto'
      }}>
        <div className="taskInPopDiv" ref={taskref}>
          <p className="taskModHead" style={{ textAlign: 'center' }}>
            Task
          </p>
          <div className="taskInScrollDiv">
            <div className="mb-2">
              {detailData?.taskName && <p className="dryClnDropText">{detailData?.taskName}</p>}
              {detailData?.selectDate && (
                <p className="taskDtDetail">Start Date: {moment(detailData?.selectDate).format('DD-MM-YYYY')}</p>
              )}
              {detailData?.endDate && (
                <p className="taskDtDetail">End Date: {moment(detailData?.endDate).format('DD-MM-YYYY')}</p>
              )}
              {detailData?.startTime && detailData?.endTime && (
                <p className="taskTimeDetail">
                  {moment(detailData?.startTime, ['HH:mm']).format('hh:mm a')} -{' '}
                  {moment(detailData?.endTime, ['HH:mm']).format('hh:mm a')}
                </p>
              )}
              {detailData?.taskStatus && <div className="taskNoteSmallHead d-flex justify-content-start align-items-center">
                {/* {detailData?.taskStatus} */}
                <p className="taskNoteSmallHead" style={{
                  width: '150px'
                }}>Status:</p>
                <div style={{
                  display: 'inline-block',

                }}>
                  <select
                    id=""
                    className="taskUpperInp"
                    name="taskStatus"
                    value={taskStatus}
                    onChange={(e) => {
                      setTaskStatus(e.target.value);
                      setIntendedTaskStatus && setIntendedTaskStatus(e.target.value);
                    }}
                  >
                    <option value="" disabled selected>
                      {language.task_select}
                    </option>
                    <option value="open">{language.open}</option>
                    <option value="doing">{language.doing}</option>
                    <option value="done">{language.done}</option>
                    <option value="ideas">{language.ideas}</option>
                    <option value="onhold">{language.on_hold}</option>
                  </select>
                </div>
              </div>}

              {detailData?.taskStatus && <div className="taskNoteSmallHead d-flex align-items-center">
                <p className="taskNoteSmallHead" style={{
                  width: '100px'
                }}>Task Notes:</p>
                {/* {detailData?.taskStatus} */}
                <div style={{
                  display: 'inline-block',
                  marginLeft: '50px'
                }}>
                  <input type="text" value={taskNotes} onChange={e => setTaskNotes(e.target.value)} />
                </div>
              </div>}

              <div className="taskNoteTextDiv">
                {
                  (detailData?.assignToUserNames && !isFromTaskList)
                  &&
                  <div className="taskNoteSmallHead d-flex align-items-center"> <p className="taskNoteSmallHead" style={{
                    width: '150px'
                  }}>Assign Users:</p>
                    {detailData.assignToUserNames.length > 0 ? (
                      <span >
                        {detailData.assignToUserNames[0]}
                        {detailData.assignToUserNames.length > 1 && ` +${detailData.assignToUserNames.length - 1} more`}
                        <button
                          onClick={toggleUserModal}
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#0C2537',
                            fontSize: '14px',
                            marginLeft: '8px'
                          }}
                          title="View All Users"
                        >
                          <i className="fa-solid fa-eye"></i>
                        </button>
                      </span>
                    ) : (
                      language.not_assigned
                    )}
                  </div>
                }

                {
                  (detailData?.assignToUser && isFromTaskList)
                  && (<div className="taskNoteSmallHead d-flex align-items-center">
                    <p className="taskNoteSmallHead" style={{
                      width: '150px'
                    }}>Assign User:</p>
                    <div style={{ display: 'inline-block', minWidth: '200px' }}>
                      <Select
                        isMulti={true}
                        options={userOptions}
                        value={selectedUsers}
                        onChange={(selectedOptions) => {
                          setSelectedUsers(selectedOptions || []);
                          setIsAssignUser(true);
                        }}
                        placeholder="Select users..."
                        className="taskUpperInpSearch"
                      />
                    </div>
                  </div>)
                }
              </div>
              {detailData?.assignToProjectName && (
                <div className="taskNoteSmallHead d-flex align-items-center"><p className="taskNoteSmallHead" style={{
                  width: '150px'
                }}>Assign Project:</p> {detailData?.assignToProjectName}</div>
              )}
              {detailData?.assignToProject && (
                <div className="taskNoteSmallHead d-flex align-items-center"><p className="taskNoteSmallHead" style={{
                  width: '150px'
                }}>Assign Project:</p> {selectedProjectName || detailData?.assignToProject}</div>
              )}
            </div>
          </div>

          <div className="tskSaveAsBtnDiv">
            <button className="tskSaveAsBtn" style={{

              background: '#0c2637',
              color: '#fff'
            }} onClick={() => {
              // handleSaveDone();
              handleSelectStatus();
              // closemodal();
            }}>
              Save
            </button>
          </div>
          <button className="closeTaskModBtn" onClick={() => closemodal()}>
            <i class="fa-solid fa-x"></i>
          </button>

          {/* User Modal */}
          {isUserModalOpen && (
            <UserModal
              users={detailData?.assignToUserNames || []}
              onClose={e => {
                e.stopPropagation();
                toggleUserModal();
              }}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default TaskPopUp;

